module.exports = __webpack_public_path__ + "img/AvatarPlatinum.74554c51.svg";